import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    redirect: '/sentences'
  },
  {
    path: '/sentences',
    name: 'SentenceHome',
    component: () => import('../views/sentences/Home.vue')
  },
  {
    path: '/sentences/profile',
    name: 'SentenceProfile',
    component: () => import('../views/sentences/Profile.vue')
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('../views/admin/Login.vue')
  },
  {
    path: '/admin',
    redirect: '/admin/dashboard'
  },
  {
    path: '/admin',
    component: () => import('../views/admin/Layout.vue'),
    meta: { requiresAuth: true },
    children: [
      {
        path: 'dashboard',
        name: 'AdminDashboard',
        component: () => import('../views/admin/Dashboard.vue')
      },
      {
        path: 'sentences',
        name: 'AdminSentences',
        component: () => import('../views/admin/Sentences.vue')
      },
      {
        path: 'codes',
        name: 'AdminCodes',
        component: () => import('../views/admin/Codes.vue')
      }
    ]
  }
]

const router = createRouter({
  history: createWebHistory(),
  routes
})

// 路由守卫
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('admin_token')
  
  if (to.meta.requiresAuth) {
    if (!token) {
      next('/admin/login')
      return
    }
  }
  
  // 已登录用户访问登录页，跳转到看板
  if (to.path === '/admin/login' && token) {
    next('/admin/dashboard')
    return
  }
  
  next()
})

export default router
